import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { isApiRequest } from '../../shared/helpers/api-request-context.helper';

export const authorizationUserInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req)) {
    return next(req);
  }

  const translocoService = inject(TranslocoService);
  const activeLang = translocoService.getActiveLang();
  const token = localStorage.getItem('encodedAccessToken');
  const headers: Record<string, string> = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (activeLang) {
    headers['Accept-Language'] = activeLang;
  }

  return next(Object.keys(headers).length > 0 ? req.clone({ setHeaders: headers }) : req);
};
